// import React from 'react';
// import { motion } from 'framer-motion';
// import { useInView } from 'framer-motion';
// import { useRef } from 'react';

// export function FadeUp({ children, delay = 0, duration = 0.6, className = '' }) {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true, margin: '-80px' });

//   return (
//     <motion.div
//       ref={ref}
//       className={className}
//       initial={{ opacity: 0, y: 40 }}
//       animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
//       transition={{ duration, delay, ease: [0.25, 0.1, 0.25, 1] }}
//     >
//       {children}
//     </motion.div>
//   );
// }

// export function FadeIn({ children, delay = 0, duration = 0.6, className = '' }) {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true, margin: '-80px' });

//   return (
//     <motion.div
//       ref={ref}
//       className={className}
//       initial={{ opacity: 0 }}
//       animate={inView ? { opacity: 1 } : { opacity: 0 }}
//       transition={{ duration, delay, ease: 'easeOut' }}
//     >
//       {children}
//     </motion.div>
//   );
// }

// export function SlideInLeft({ children, delay = 0, duration = 0.7, className = '' }) {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true, margin: '-80px' });

//   return (
//     <motion.div
//       ref={ref}
//       className={className}
//       initial={{ opacity: 0, x: -60 }}
//       animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -60 }}
//       transition={{ duration, delay, ease: [0.25, 0.1, 0.25, 1] }}
//     >
//       {children}
//     </motion.div>
//   );
// }

// export function SlideInRight({ children, delay = 0, duration = 0.7, className = '' }) {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true, margin: '-80px' });

//   return (
//     <motion.div
//       ref={ref}
//       className={className}
//       initial={{ opacity: 0, x: 60 }}
//       animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: 60 }}
//       transition={{ duration, delay, ease: [0.25, 0.1, 0.25, 1] }}
//     >
//       {children}
//     </motion.div>
//   );
// }

// export function ScaleIn({ children, delay = 0, duration = 0.5, className = '' }) {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true, margin: '-80px' });

//   return (
//     <motion.div
//       ref={ref}
//       className={className}
//       initial={{ opacity: 0, scale: 0.85 }}
//       animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.85 }}
//       transition={{ duration, delay, ease: [0.34, 1.56, 0.64, 1] }}
//     >
//       {children}
//     </motion.div>
//   );
// }

// export function StaggerChildren({ children, staggerDelay = 0.1, className = '' }) {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true, margin: '-60px' });

//   return (
//     <motion.div
//       ref={ref}
//       className={className}
//       initial="hidden"
//       animate={inView ? 'visible' : 'hidden'}
//       variants={{
//         hidden: {},
//         visible: { transition: { staggerChildren: staggerDelay } },
//       }}
//     >
//       {children}
//     </motion.div>
//   );
// }

// export function StaggerItem({ children, className = '' }) {
//   return (
//     <motion.div
//       className={className}
//       variants={{
//         hidden: { opacity: 0, y: 30 },
//         visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] } },
//       }}
//     >
//       {children}
//     </motion.div>
//   );
// }

import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export function FadeUp({ children, delay = 0, duration = 0.6, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, margin: '-80px' });
  return (
    <motion.div ref={ref} className={className}
      initial={{ opacity: 0, y: 40 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
      transition={{ duration, delay, ease: [0.25, 0.1, 0.25, 1] }}>
      {children}
    </motion.div>
  );
}

export function FadeIn({ children, delay = 0, duration = 0.6, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, margin: '-80px' });
  return (
    <motion.div ref={ref} className={className}
      initial={{ opacity: 0 }}
      animate={inView ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration, delay, ease: 'easeOut' }}>
      {children}
    </motion.div>
  );
}

export function SlideInLeft({ children, delay = 0, duration = 0.7, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, margin: '-80px' });
  return (
    <motion.div ref={ref} className={className}
      initial={{ opacity: 0, x: -60 }}
      animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -60 }}
      transition={{ duration, delay, ease: [0.25, 0.1, 0.25, 1] }}>
      {children}
    </motion.div>
  );
}

export function SlideInRight({ children, delay = 0, duration = 0.7, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, margin: '-80px' });
  return (
    <motion.div ref={ref} className={className}
      initial={{ opacity: 0, x: 60 }}
      animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: 60 }}
      transition={{ duration, delay, ease: [0.25, 0.1, 0.25, 1] }}>
      {children}
    </motion.div>
  );
}

export function ScaleIn({ children, delay = 0, duration = 0.5, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, margin: '-80px' });
  return (
    <motion.div ref={ref} className={className}
      initial={{ opacity: 0, scale: 0.85 }}
      animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.85 }}
      transition={{ duration, delay, ease: [0.34, 1.56, 0.64, 1] }}>
      {children}
    </motion.div>
  );
}

export function StaggerChildren({ children, staggerDelay = 0.1, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, margin: '-60px' });
  return (
    <motion.div ref={ref} className={className}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: staggerDelay } },
      }}>
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = '' }) {
  return (
    <motion.div className={className}
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] } },
      }}>
      {children}
    </motion.div>
  );
}